import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';

import { MapaService } from '../../../services/mapa.service';

@Component({
  selector: 'app-circunscripciones',
  templateUrl: './circunscripciones.component.html',
  styleUrls: ['./circunscripciones.component.css']
})
export class CircunscripcionesComponent implements OnInit {
  municipio:any = [];
  opcionSeleccionado:string='';
  verSeleccion:string = '';
    constructor(private titleService: Title,
                private _estado:MapaService) {
    this.getCortes();
                }

    ngOnInit() {

      AOS.init({
        duration: 500,
        easing: 'linear',
      });

      this.titleService.setTitle('Consulta tu distrito | CentroAyuda PREP');
    }

    getCortes(){
      this._estado.getmunicipios()
      .subscribe(data=>{
        this.municipio=data;
        console.log(this.municipio)
      },error=>{
        console.log(error)
      })
    }

    capturar(posicion) {
      this.verSeleccion = this.municipio[posicion];
    }

  }



// WEBPACK FOOTER //
// ./src/app/components/elecciones-federales/circunscripciones/circunscripciones.component.ts